import React from "react";
import { MessageSquare, BookOpen, Mail, LifeBuoy } from "lucide-react";
import { toast } from "sonner";
import TopBar from "../components/layout/TopBar";

const ITEMS = [
  { icon: BookOpen, title: "Getting started guide", body: "Understand your Growth Score, competitors and the weekly loop." },
  { icon: MessageSquare, title: "Message your Growth Team", body: "Managed customers can reach their content team directly." },
  { icon: Mail, title: "Email support", body: "We reply to every message within one working day." },
];

export default function Help() {
  return (
    <>
      <TopBar title="Help" subtitle="We're here when you need us." />
      <div className="p-6 sm:p-8 max-w-[900px]">
        <div className="card p-8 mb-6 flex items-center gap-5" style={{ background: "rgba(147,192,32,.05)" }}>
          <span className="grid place-items-center w-14 h-14 rounded-xl" style={{ background: "#151515" }}><LifeBuoy size={26} color="#93C020" strokeWidth={1.75} /></span>
          <div>
            <h2 className="text-xl font-bold tracking-tight text-ink">How can we help?</h2>
            <p className="text-ink-2 mt-1">Growth is designed to always connect insight to action. If anything's unclear, we'll guide you.</p>
          </div>
        </div>
        <div className="grid sm:grid-cols-3 gap-4">
          {ITEMS.map((it) => (
            <button key={it.title} onClick={() => toast.success("Thanks — we'll be in touch")} data-testid={`help-${it.title.split(" ")[0].toLowerCase()}`}
              className="card card-hover p-5 text-left">
              <it.icon size={20} strokeWidth={1.5} color="#678A16" />
              <h3 className="font-semibold text-ink mt-3">{it.title}</h3>
              <p className="text-sm text-ink-2 mt-1">{it.body}</p>
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
